import React from 'react';
import leafImage from '../assets/leaf.png';
import directorImage from '../assets/director.jpg';

// Custom styles for Director component
const styles = `
.director-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 80px 0;
}

/* Decorative circle - Top Left */
.director-decoration-circle {
    position: absolute;
    top: -80px;
    left: -80px;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay on circle */
.director-decoration-leaf {
    position: absolute;
    top: -60px;
    left: -60px;
    width: 240px;
    height: 240px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

.director-content-wrapper {
    position: relative;
    z-index: 3;
}

/* Main Heading */
.director-main-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.5rem;
    font-weight: 800;
    color: #5A3411;
    text-align: center;
    margin-bottom: 50px;
}

/* Content Section */
.director-content {
    display: flex;
    align-items: flex-start;
    gap: 50px;
    position: relative;
}

.director-text-section {
    flex: 1;
}

.director-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1rem;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.7;
    margin-bottom: 20px;
    text-align: justify;
}

.director-text-bold {
    font-weight: 600;
    color: #5A3411;
}

.director-list {
    list-style: none;
    padding-left: 0;
    margin-bottom: 20px;
}

.director-list li {
    font-family: 'Quicksand', sans-serif;
    font-size: 1rem;
    color: #5A3411;
    font-weight: 600;
    line-height: 1.6;
    margin-bottom: 5px;
    position: relative;
    padding-left: 15px;
}

.director-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #5A3411;
    font-weight: 700;
}

.director-closing {
    font-family: 'Quicksand', sans-serif;
    font-size: 1rem;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.7;
    font-style: italic;
    margin-bottom: 0;
}

/* Director Image Section */
.director-image-section {
    flex: 0 0 300px;
    max-width: 300px;
    align-self: stretch;
    display: flex;
}

.director-image-wrapper {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    width: 100%;
    position: relative;
}

.director-image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    object-fit: cover;
    object-position: top center;
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .director-section {
        padding: 70px 0;
    }
    
    .director-main-heading {
        font-size: 2.3rem;
        margin-bottom: 45px;
    }
    
    .director-image-section {
        flex: 0 0 320px;
        max-width: 320px;
    }
    
    .director-content {
        gap: 40px;
    }
}

@media (max-width: 991.98px) {
    .director-section {
        padding: 60px 0;
    }
    
    .director-main-heading {
        font-size: 2rem;
        margin-bottom: 40px;
    }
    
    .director-content {
        flex-direction: column-reverse;
        align-items: center;
        gap: 35px;
    }
    
    .director-text-section {
        width: 100%;
    }
    
    .director-image-section {
        flex: 0 0 auto;
        max-width: 350px;
        width: 100%;
        align-self: center;
    }
    
    .director-image-wrapper {
        height: auto;
        position: static;
    }
    
    .director-image {
        position: static;
        height: auto;
    }
    
    .director-text {
        font-size: 0.95rem;
        text-align: left;
    }
    
    .director-decoration-circle {
        width: 220px;
        height: 220px;
        top: -70px;
        left: -70px;
    }
    
    .director-decoration-leaf {
        width: 190px;
        height: 190px;
        top: -50px;
        left: -50px;
    }
}

@media (max-width: 767.98px) {
    .director-section {
        padding: 50px 0;
    }
    
    .director-main-heading {
        font-size: 1.75rem;
        margin-bottom: 35px;
        padding: 0 15px;
    }
    
    .director-content {
        gap: 30px;
    }
    
    .director-image-section {
        max-width: 300px;
    }
    
    .director-text {
        font-size: 0.9rem;
        line-height: 1.65;
        margin-bottom: 15px;
    }
    
    .director-list li {
        font-size: 0.9rem;
    }
    
    .director-closing {
        font-size: 0.9rem;
    }
    
    .director-decoration-circle {
        width: 180px;
        height: 180px;
        top: -60px;
        left: -60px;
    }
    
    .director-decoration-leaf {
        width: 150px;
        height: 150px;
        top: -40px;
        left: -40px;
    }
    
    .director-image-wrapper {
        border-radius: 16px;
    }
}

@media (max-width: 575.98px) {
    .director-section {
        padding: 40px 0;
    }
    
    .director-main-heading {
        font-size: 1.5rem;
        margin-bottom: 30px;
    }
    
    .director-content {
        gap: 25px;
    }
    
    .director-image-section {
        max-width: 260px;
    }
    
    .director-text {
        font-size: 0.85rem;
        line-height: 1.6;
        margin-bottom: 12px;
    }
    
    .director-list li {
        font-size: 0.85rem;
        margin-bottom: 4px;
    }
    
    .director-closing {
        font-size: 0.85rem;
    }
    
    .director-decoration-circle {
        width: 140px;
        height: 140px;
        top: -50px;
        left: -50px;
    }
    
    .director-decoration-leaf {
        width: 120px;
        height: 120px;
        top: -35px;
        left: -35px;
    }
    
    .director-image-wrapper {
        border-radius: 14px;
    }
}

@media (max-width: 400px) {
    .director-section {
        padding: 35px 0;
    }
    
    .director-main-heading {
        font-size: 1.3rem;
        margin-bottom: 25px;
    }
    
    .director-image-section {
        max-width: 220px;
    }
    
    .director-text {
        font-size: 0.8rem;
        line-height: 1.55;
    }
    
    .director-list li {
        font-size: 0.8rem;
    }
    
    .director-closing {
        font-size: 0.8rem;
    }
    
    .director-decoration-circle {
        width: 110px;
        height: 110px;
        top: -40px;
        left: -40px;
    }
    
    .director-decoration-leaf {
        width: 95px;
        height: 95px;
        top: -28px;
        left: -28px;
    }
    
    .director-image-wrapper {
        border-radius: 12px;
    }
}
`;

const Director = () => {
    return (
        <>
            <style>{styles}</style>
            <section className="director-section">
                {/* Decorative Circle */}
                <div className="director-decoration-circle"></div>
                {/* Decorative Leaf */}
                <div
                    className="director-decoration-leaf"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>

                <div className="container">
                    <div className="director-content-wrapper">
                        {/* Main Heading */}
                        <h2 className="director-main-heading">Message from the Director</h2>

                        {/* Content Row */}
                        <div className="row">
                            <div className="col-12">
                                <div className="director-content">
                                    {/* Text Section */}
                                    <div className="director-text-section">
                                        <p className="director-text">
                                            As Director, <span className="director-text-bold">Saania Qudrat</span>, and with experience in both Australia and the UK, I have shaped Zubis Nursery to be a place where children feel safe, confident, and excited to learn. Our approach blends hygge-inspired comfort with curiosity-led learning, supporting children to grow emotionally, socially, and as capable, confident learners. Strong relationships are at the core of our practice, and our dedicated team works with genuine care for every child and family.
                                        </p>

                                        <p className="director-text">
                                            At Zubis Nursery, we are committed to ensuring:
                                        </p>

                                        <ul className="director-list">
                                            <li>Children feel happy, secure, and inspired</li>
                                            <li>Staff feel valued and supported</li>
                                            <li>Families feel welcomed and included</li>
                                        </ul>

                                        <p className="director-closing">
                                            We look forward to making magical memories with your family.
                                        </p>
                                    </div>

                                    {/* Image Section */}
                                    <div className="director-image-section">
                                        <div className="director-image-wrapper">
                                            <img
                                                src={directorImage}
                                                alt="Director - Saania Qudrat"
                                                className="director-image"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Director;
